import ToastContainer from '../../components/Toast';
import Api from '../../components/Toast/api';
import Positions from '../../components/Toast/positions';

const install = (Vue, options = {}) => {
  const methods = Api(Vue, {
    type: 'success',
    icon: 'default',
    ...options,
  });
  Vue.$toastPlugin = methods;
  Vue.prototype.$toastPlugin = methods;
};

export default install;
export { ToastContainer, Positions };
